import { FC } from "react";
import RoundedIcon from "../dashboard/RoundedIcon";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

interface ProjectItemCreateProps {
}
 
const ProjectItemCreate: FC<ProjectItemCreateProps> = () => {
    return (
      <Link to={`/architecture/create`} className="block">
        <div data-tour="projects-list" className="border-dashed border-2 border-fuchsia-600 rounded-lg flex flex-col justify-center items-center gap-2 sm:gap-3 cursor-pointer min-h-[120px] sm:min-h-[150px] p-3 sm:p-4 create_project hover:bg-fuchsia-50 transition-colors">
          <RoundedIcon color="fuchsia-600" height="h-8 sm:h-11" width="w-8 sm:w-11">
            <Plus className="m-auto text-fuchsia-600" />
          </RoundedIcon>
          <p className="text-fuchsia-600 text-center text-sm sm:text-lg font-medium">
            Create a new project
          </p>
          <p className="text-fuchsia-600 text-center text-xs sm:text-sm px-2">
            Generate here a new project, with specifications, architecture
            diagram, code, etc.
          </p>
        </div>
      </Link>
    );
}
 
export default ProjectItemCreate;